import React, { useEffect, useState } from "react";
import ProductList from "../components/ProductList";
import CategoryList from "../components/CategoryList";
import BestSellerProducts from "../components/BestSellerProducts";
import { Helmet } from 'react-helmet-async';

import { useNavigate,Link } from "react-router-dom";
import StoreLocator from "../components/StoreLocator";

const Homepage = () => {
  const [products, setProducts] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState(null); // Track the active accordion
  const navigate = useNavigate();
  const heroImage ="https://www.butterflyassets.online/purple_gummies.webp";
  const token = localStorage.getItem("token");



  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          "https://supplement-app-d151447d38d4.herokuapp.com/api/products/store/677002f923896fcda6ab960d"
        );
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  // Function to toggle the accordion
  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="homepage">
      
<Helmet>
                <title>Sunnyside: Medical and recreational dispensaries|THC gummies & edibles|Fast shipping & delivery</title>
                <meta name="description" content="Sunnyside allows you to buy THC carts, THC gummies & edibles in-store or online.Use the store locator to find stores near you."/>
            </Helmet>
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center h-[400px]"
        style={{
          backgroundImage: `url("${heroImage}")`,
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Welcome to SunnySide
            </h1>
            <p className="text-lg md:text-xl text-white">
              SunnySide is new kind of Dispensary where you get to buy your favorite cannabis products for medical and recreational purposes, THC gummies & edibles in-store or online.You can place your order online and have delivery next day to all 50 states.You can also visit the store locator section and buy in-store.There are amazing deals for Gummies and edibles.We know you like only the best and Sunnyvale is here to provide only the best.
            </p>
            <button
              className="mt-6 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700"
              onClick={() => navigate("/shop")}
            >
              Shop Now
            </button>
          </div>
        </div>
      </section>

      {/* Promotional Section */}
      <section className="py-16 bg-gray-100 text-center">
        <h2 className="text-3xl font-bold mb-6">Why you should use Sunnyside</h2>
        <div className="flex flex-wrap justify-center space-x-6">
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">Shop the best THC carts and THC gummies online and in-store.</h3>
            <p className="text-gray-600">
              Gain rewards through our special royalty program.
            </p>
          </div>
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">Premium cannabis brands</h3>
            <p className="text-gray-600">
              SHop for adult use or medical reasons depending on your state.
            </p>
          </div>
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">Quality over quantity</h3>
            <p className="text-gray-600">
              We have all your best and trusted brands in one place.
            </p>
          </div>
        </div>
      </section>
      <CategoryList/>
      <BestSellerProducts/>
      <StoreLocator token={token}/>
      {/* FAQ Section */}
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold text-center mb-6">New to Sunnyside?, Here are some FAQ</h2>
        <div>
          {[
            {
              question: "is it legal to order THC carts online?",
              answer:
                "You must be 21+ to order from our website,shop according to the legislation of your state.",
            },
            {
              question: "what is the THC content of your Vape cartridges?",
              answer:
                "The strongest THC carts we have contain percentages of up 95%.",
            },
            {
              question: "How long does shipping take if i order online?",
              answer:
                "Our shipping is extremely fast,we deliver from 24-72 hours",
            },
            {
              question: "Do you have a refund policy?",
              answer:
                "Yes,we have a 30-day money back refund policy.",
            },
          ].map((faq, index) => (
            <div
              key={index}
              className="border border-gray-300 rounded-md mb-4"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="flex justify-between w-full p-4 text-lg font-semibold focus:outline-none"
              >
                {faq.question}
                <span>{activeAccordion === index ? "-" : "+"}</span>
              </button>
              {activeAccordion === index && (
                <div className="p-4 text-gray-600">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
     
    </div>
  );
};

export default Homepage;
